import React, { useEffect, useRef, useState } from "react";
import EasyBinTransfer_Breadcrumbs from "../../EasyBinTransfer_Breadcrumbs";
import { Grid } from "@mui/material";
import {
  CmpButton,
  CmpDatePicker,
  CmpDatePickerField,
  CmpInputField,
  CmpSelectBox,
  CmpSelectField,
  CmpTextFieldEnter,
  CmpTypographyField,
} from "../../../../Component/Common/ToolBox/ToolBox";
import { useDispatch, useSelector } from "react-redux";
import GCToggleSearch from "../../../../Component/Common/ReuseableComponent/GCToggleSearch";
import { GetDes, fBinNameToKey, fIsEnable } from "../../EasyBinTransferAction";
import { Src_Set } from "../../SliceEasyBinTransfer";
import { fAlertToast } from "../../../../Utility/Utilitys";
import { useNavigate } from "react-router-dom";

export default function EasyBinTransferDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const vRdxSrc = useSelector((state) => state.SliceEasyBinTransfer.value.Src);
  const onChangeInput = (e) => {
    dispatch(
      Src_Set({
        ...vRdxSrc,
        [e.target.name]: e.target.value,
      })
    );
  };
  const xfocus = (e) => {
    if ( (e.key === "Enter" || e?._reactName === "onClick" ) && vRdxSrc.BinCodeTo != "" ) {
      // document.getElementsByName("BarCode")[0]?.focus()
      document.getElementById("Save").click();
    }
  };
  const FocusOnLoad = useRef(null);
  useEffect(() => {
    FocusOnLoad.current?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex my-3">
        <EasyBinTransfer_Breadcrumbs />
      </div>
      <div className="BinTransferContainer">
        <div className="BinTransferData">
          <div className="gridStyle">
            <Grid
              container
              columnSpacing={1}
              rowSpacing={2}
              columns={{ xs: 12, sm: 12, md: 12 }}
            >
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Trans ID"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"DocNo"}
                  xReadOnly={true}
                  xOnChange={() => {}}
                  xValue={vRdxSrc.DocNo}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Trans Date"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <CmpDatePickerField
                  xtabIndex={"2"}
                  xValue={vRdxSrc.Date}
                  xOnChange={(newValue) => {
                    //  dispatch(
                    //   Src_Set({
                    //     ...vRdxSrc,
                    //     Date: newValue.$d,
                    //   })
                    // )
                  }}
                  xName={"Date"}
                  xDisable={true}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Bin To"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              {/* <Grid item xs={3} sm={4} md={3} lg={3}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"BinCodeTo"}
                  xReadOnly={true}
                  xOnChange={""}
                  xValue={vRdxSrc.BinCodeTo}
                />
              </Grid> */}
              <Grid item xs={8} sm={9} md={8} lg={8}>
                {/* <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"BinNameTo"}
                  xReadOnly={true}
                  xOnChange={""}
                  xValue={vRdxSrc.BinNameTo}
                /> */}
                <GCToggleSearch
                  xref={FocusOnLoad}
                  xtabIndex={"25"}
                  xName={"BinNameTo"}
                  xType={"text"}
                  xValue={vRdxSrc.BinNameTo}
                  xOnKeyUp={async (e) => {
                    await fBinNameToKey(e, dispatch,xfocus);
                  }}
                  xReadOnly={fIsEnable() ? true : false}
                  xOnChange={(event) => onChangeInput(event)}
                  xError={false}
                  xErrorMessage={""}
                  xMediaQuery={false}
                  xonClickbtn={async (e) => {
                    await fBinNameToKey(e, dispatch,xfocus);
                  }}
                />
              </Grid>
              <Grid
                item
                lg={12}
                md={12}
                xs={12}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                className="bintransfet-data-load-btn"
              >
                <CmpButton
                xId="Save"
                  xbtnName="Save"
                  xDisabled={fIsEnable()}
                  xOnClick={async () => {
                    if (vRdxSrc.BinCodeTo == "") {
                      fAlertToast("FAILED", "Bin To Should not be empty");
                      return;
                    } else {
                      await GetDes(navigate);
                    }
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
}
